import { useEffect, useRef } from 'react'
import { registerCrispYieldHandler } from '../util/crisp-priority'
import { hideChat, isChatHidden, showChat } from '../util/set-crisp-session-info'

interface IUseCrispYieldParams {
  isOpen: boolean
  // Must close the panel; must be idempotent (openChat yields directly and chat:opened fires too).
  onYield: () => void
}

// Hides the Crisp widget while the panel is open, and closes the panel
// whenever Crisp needs the stage (operator message, trigger, support click).
export const useCrispYield = ({ isOpen, onYield }: IUseCrispYieldParams): void => {
  const onYieldRef = useRef(onYield)
  onYieldRef.current = onYield

  useEffect(() => {
    if (!isOpen) {
      return
    }
    // Chat can already be hidden for other reasons (e.g. freemium non-admins);
    // only re-show it if we were the ones who hid it.
    const wasHidden = isChatHidden()
    hideChat()
    const unregister = registerCrispYieldHandler(() => onYieldRef.current())
    return () => {
      unregister()
      if (!wasHidden) {
        showChat()
      }
    }
  }, [isOpen])
}
